import React, { useState, useEffect } from "react";
import "./Orders.css";
import DataCard from "./../../components/common/DataCard/DataCard";
import { useGetOrdersSummeryByUserIdQuery } from "./orderSlice";
import { selectCurrentUser } from "./../auth/authSlice";
import { useSelector } from "react-redux";

import OrdersTable from "./OrdersTable";

const Orders = () => {
  const user = useSelector(selectCurrentUser);

  const [type, setType] = useState("month");
  const [selectedUserID, setSelectedUserID] = useState(user.userID);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedUser, setSelectedUser] = useState("all");
  const [individualSummaryDataTitle, setIndividualSummaryDataTitle] =
    useState("All Sales");

  function handleChildClick(value, startDate, endDate) {
    setType(value);
    setStartDate(startDate);
    setEndDate(endDate);
  }

  function handleEmployeeSelection(value) {
    setSelectedUserID(value === "all" ? user.userID : value.userId);
    setSelectedUser(value);
  }

  const { data: orderSummary } = useGetOrdersSummeryByUserIdQuery({
    userId: selectedUserID,
    type: type,
    startDate: startDate,
    endDate: endDate,
  });

  const [individualSummaryData, setIndividualSummaryData] = useState({
    current: 0,
    target: 0,
    isMonitory: true,
  });

  const [teamSummaryData, setTeamSummaryData] = useState({
    current: 0,
    target: 0,
    isMonitory: true,
  });

  useEffect(() => {
    if (orderSummary) {
      setIndividualSummaryData({
        current:
          selectedUser === "all"
            ? orderSummary.teamAchievement
            : orderSummary.individualAchievement,
        target:
          selectedUser === "all"
            ? orderSummary.teamTarget
            : orderSummary.individualTarget,
        isMonitory: true,
      });
      setTeamSummaryData({
        current: orderSummary.teamAchievement,
        target: orderSummary.teamTarget,
        isMonitory: true,
      });
    }
  }, [orderSummary, selectedUser]);

  useEffect(() => {
    if (selectedUser === "all") {
      setIndividualSummaryDataTitle("All Sales");
    } else {
      setIndividualSummaryDataTitle(
        `${selectedUser.firstName} ${selectedUser.lastName}'s Sales`,
      );
    }
  }, [selectedUserID, selectedUser, type, startDate, endDate]);

  return (
    <>
      <div className="row mb-2 mx-md-0">
        <div className="col-md-6 col-sm-12 pe-md-1 data-card-column-left">
          <DataCard
            data={individualSummaryData}
            title={individualSummaryDataTitle}
          />
        </div>
        <div className="col-md-6 col-sm-12 ps-md-1 data-card-column-right">
          <DataCard data={teamSummaryData} title={"Team Sales"} />
        </div>
      </div>
      <div className="card content-card">
        <div className="card-body">
          <OrdersTable
            handleFilter={handleChildClick}
            handleEmployeeSelection={handleEmployeeSelection}
          />
        </div>
      </div>
    </>
  );
};

export default Orders;
